/* RAVIN / FIT LAB / PAPER BAG CHARACTERS / 18 OCT 2026
 * Visual + interaction enhancement only; original Fit Lab request/validation untouched.
 * Separate removable module; does not affect chapters 02/03 or size chart data.
 */
(()=>{
  if(window.__RavinFitLabCharacter2026)return;
  window.__RavinFitLabCharacter2026=true;
  const CHAPTER='1';
  const required=['chestBustCm','waistCm','hipsCm'];
  const isMobile=()=>window.matchMedia('(max-width:749px)').matches;
  const escapeHTML=s=>String(s??'').replace(/[&<>"']/g,c=>({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  }[c]));
  let overlay=null;
  let active=false;
  let pending=false;

  function detectGender(root){
    const words=[
      root?.dataset.productType,root?.dataset.productTitle,
      root?.dataset.productHandle,root?.dataset.productTags,
      root?.dataset.productCollections
    ].filter(Boolean).join(' ').toLowerCase();
    if(/(?:^|[^a-z])(women|womens|woman|female|ladies|girls|girl)(?:$|[^a-z])|حريمي|حريم|نسائي|بنات|سيدات/i.test(words))return 'women';
    if(/(?:^|[^a-z])(men|mens|man|male|boys|boy)(?:$|[^a-z])|رجالي|رجال|شباب/i.test(words))return 'men';
    return 'neutral';
  }
  const lines={
    women:{
      chest:'M 374 444 Q 550 481 694 446',
      waist:'M 429 566 Q 549 592 674 565',
      hips:'M 395 690 Q 571 725 726 671'
    },
    men:{
      chest:'M 338 657 Q 545 731 761 652',
      waist:'M 370 855 Q 556 897 738 845',
      hips:'M 334 1038 Q 567 1090 789 1020'
    }
  };
  function decorateCharacter(ov,root){
    if(ov.dataset.rvFlView!=='fit'||ov.dataset.rvFlChapter!==CHAPTER)return;
    const figure=ov.querySelector('.rv-fl-guided-character');
    if(!figure||figure.dataset.rvBrandCharacter==='true')return;
    const gender=detectGender(root);
    const src=gender==='men'?root?.dataset.rvFlMaleAsset:
      gender==='women'?root?.dataset.rvFlFemaleAsset:'';
    if(!src||!lines[gender])return; // Keep existing neutral illustration for unisex/unknown.
    const existing=figure.querySelector(':scope > svg');
    if(!existing)return;
    const ar=(ov.getAttribute('dir')==='rtl'||document.documentElement.lang==='ar');
    const alt=gender==='men'?
      (ar?'شخصية ريفين بشورت سباحة توضح قياسات الصدر والخصر والأرداف':
      'RAVIN paper-bag character in swim trunks demonstrating chest, waist and hip measurements'):
      (ar?'شخصية ريفين توضح قياسات الصدر والخصر والأرداف':
      'RAVIN paper-bag character demonstrating chest, waist and hip measurements');
    const markup='<div class="rv-fl-brand-character__art" data-rv-brand-gender="'+gender+'">'+
      '<img class="rv-fl-brand-character__photo" src="'+escapeHTML(src)+'" alt="'+escapeHTML(alt)+
      '" decoding="async" loading="eager">'+
      '<svg class="rv-fl-brand-character__marks" aria-hidden="true" viewBox="0 0 1122 1402" preserveAspectRatio="xMidYMid meet">'+
      Object.entries(lines[gender]).map(([zone,path])=>
        '<path class="rv-fl-brand-character__mark" data-rv-zone="'+zone+'" d="'+path+'"/>').join('')+
      '</svg></div>';
    existing.insertAdjacentHTML('beforebegin',markup);
    existing.remove();
    figure.dataset.rvBrandCharacter='true';
    figure.dataset.rvBrandGender=gender;
  }
  function syncCTA(ov){
    if(ov.dataset.rvFlView!=='fit'||ov.dataset.rvFlChapter!==CHAPTER)return;
    const form=ov.querySelector('[data-rv-fl-measure-form]');
    if(!form)return;
    const done=required.filter(name=>{
      const input=form.querySelector('[data-field="'+name+'"]');
      return !!input&&input.value.trim()!==''&&input.checkValidity();
    }).length;
    const ready=done===required.length;
    ov.dataset.rvFlReady=String(ready);
    for(const button of [ov.querySelector('[data-rv-fl-mobile-continue]'),form.querySelector('.rv-fl-guided-inline-continue')]){
      if(!button)continue;
      if(button.disabled!==!ready)button.disabled=!ready;
      button.setAttribute('aria-disabled',String(!ready));
    }
    let counter=ov.querySelector('[data-rv-fl-live-count]');
    if(!counter){
      const fields=form.querySelector('.rv-fl-guided-required-fields');
      if(fields){
        counter=document.createElement('p');
        counter.className='rv-fl-guided-entry-count';
        counter.setAttribute('data-rv-fl-live-count','');
        counter.setAttribute('role','status');
        counter.setAttribute('aria-live','polite');
        fields.insertAdjacentElement('afterend',counter);
      }
    }
    if(counter){
      const text=(ov.getAttribute('dir')==='rtl'?
        done+' / ٣ قياسات':done+' / 3 measurements');
      if(counter.textContent!==text)counter.textContent=text;
    }
  }
  function syncVisualViewport(){
    if(!overlay||!active||!isMobile()||!window.visualViewport)return;
    const v=window.visualViewport;
    overlay.style.top=v.offsetTop+'px';
    overlay.style.bottom='auto';
    overlay.style.height=v.height+'px';
  }
  function resetVisualViewport(){
    if(!overlay)return;
    overlay.style.top='';
    overlay.style.bottom='';
    overlay.style.height='';
  }
  function getOpenOverlay(){
    return document.querySelector('.rv-fl-overlay[data-open="true"]');
  }
  function sync(){
    pending=false;
    const next=getOpenOverlay();
    if(next!==overlay){
      if(active){
        window.visualViewport?.removeEventListener('resize',syncVisualViewport);
        window.visualViewport?.removeEventListener('scroll',syncVisualViewport);
        resetVisualViewport();
      }
      overlay=next;
      active=Boolean(next);
      if(active){
        window.visualViewport?.addEventListener('resize',syncVisualViewport);
        window.visualViewport?.addEventListener('scroll',syncVisualViewport);
      }
    }
    if(!overlay)return;
    syncVisualViewport();
    const root=document.querySelector('[data-rv-fitlab]');
    if(!root)return;
    decorateCharacter(overlay,root);
    syncCTA(overlay);
  }
  function scheduleSync(){
    if(pending)return;
    pending=true;
    queueMicrotask(sync);
  }
  function whenReady(){
    if(!document.body)return;
    const observer=new MutationObserver(scheduleSync);
    observer.observe(document.body,{
      childList:true,subtree:true,attributes:true,
      attributeFilter:['data-open','data-rv-fl-chapter','data-rv-fl-view']
    });
    document.addEventListener('input',event=>{
      if(event.target.matches?.('.rv-fl-overlay [data-field]'))syncCTA(getOpenOverlay()||overlay);
    },true);
    document.addEventListener('change',event=>{
      if(event.target.matches?.('.rv-fl-overlay [data-field]'))syncCTA(getOpenOverlay()||overlay);
    },true);
    window.addEventListener('resize',scheduleSync);
    scheduleSync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',whenReady,{once:true});
  else whenReady();
})();